import React from "react";

export default () => {
  return (
    <React.Fragment>
      <rect x="0" y="15" rx="4" ry="4" width="250" height="6" />
      <rect x="0" y="25" rx="4" ry="4" width="220" height="6" />
      <rect x="0" y="35" rx="4" ry="4" width="200" height="6" />
      <rect x="0" y="45" rx="4" ry="4" width="180" height="6" />
      <rect x="0" y="55" rx="4" ry="4" width="160" height="6" />
    </React.Fragment>
  );
};
